<template>
    <div class="saveOrUpdateCrud">
        <div>
            <el-page-header @back="close" :content="title + '专业信息'"></el-page-header>
        </div>
        <el-form :model="upsertForm"  :rules="rules" ref="upsertForm" label-width="80px" style="margin-top: 20px;" :inline="true" >
            <input type="hidden" :value="upsertForm.id">
              <div style="width: 100%">
                  <el-form-item label="专业代码" prop="code">
                      <el-input size="mini" maxlength="32" placeholder="请输入专业代码" show-word-limit  v-model="upsertForm.code" auto-complete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="专业名称" prop="name">
                      <el-input size="mini" maxlength="32" placeholder="请输入专业名称" show-word-limit  v-model="upsertForm.name" auto-complete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="生效年份" v-if="type!=-1" prop="year">
                      <el-date-picker
                              size="mini"
                              v-model="upsertForm.year"
                              type="year"
                              placeholder="选择生效年份"
                              format="yyyy"
                              value-format="yyyy" >
                      </el-date-picker>
                  </el-form-item>
                  <el-form-item label="生效年份" v-if="type==-1">
                      <el-date-picker
                              size="mini"
                              v-model="upsertForm.year"
                              type="year"
                              placeholder="选择生效年份"
                              format="yyyy"
                              value-format="yyyy" >
                      </el-date-picker>
                  </el-form-item>
                  <el-form-item label="专业代码" prop="majorCode">
                      <el-input size="mini" maxlength="2" show-word-limit  v-model="upsertForm.majorCode" placeholder="请输入专业编号" auto-complete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="考试须知" prop="xz">
                      <ckeditor v-model="upsertForm.xz"></ckeditor>
                  </el-form-item>
                  <el-form-item>
                      <el-button size="mini" @click="close">取 消</el-button>
                      <el-button size="mini" type="primary" v-if="title=='增加'" v-display:sysMajor-save @click="saveOrUpdate('upsertForm')">确 定</el-button>
                      <el-button size="mini" type="primary" v-else v-display:sysMajor-update @click="saveOrUpdate('upsertForm')">确 定</el-button>
                  </el-form-item>
              </div>
            <div style="border-top: dashed 1px #1989FA;padding-top: 10px;margin-top: 20px" v-if="this.title=='修改'">
                <div style="margin-bottom: 10px;float: right;margin-right: 10px" >
                    <el-button plain size="mini" type="success" icon="el-icon-refresh-left" @click="()=>{this.searchForm.pager.page=1;this.submit(id);}">刷新</el-button>
                    <el-button plain size="mini" type="primary" v-display:sysMajorItem-save icon="el-icon-plus" @click="showAddDialog" >新增</el-button>
                </div>
                <el-table border size="mini" class="table-ui" :stripe="true"  :data="tableData" >
                    <el-table-column show-overflow-tooltip prop="sequence" label="科目序号" >
                        <template slot-scope="scope">
                            <span v-if="scope.row.sequence">考试科目{{scope.row.sequence}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="name" label="科目名称" ></el-table-column>
                    <el-table-column show-overflow-tooltip prop="examDay" label="考试日期" ></el-table-column>
                    <el-table-column show-overflow-tooltip prop="examStartTime" label="考试开始" ></el-table-column>
                    <el-table-column show-overflow-tooltip prop="examEndTime" label="考试结束" ></el-table-column>
                    <el-table-column fixed="right" label="操作" width="120"  >
                        <template slot-scope="scope">
                            <el-button type="text" v-display:sysMajorItem-update @click="showUpdateDialog(scope.row.id)">修改</el-button>
                            <el-button type="text" v-display:sysMajorItem-delete @click="deleteData(scope.row.id)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-form>
        <!--添加或者修改表单-->
        <el-dialog :close-on-click-modal="false" :title="dialog.title"   width="600px" :visible.sync="dialog.dialogFormVisible">
            <el-form class="upsertForm"  :model="majorItemForm" :rules="majorRules" ref="majorItemForm" label-width="100px" :inline="true">
                <input type="hidden" :value="majorItemForm.id">
                <el-form-item label="科目名称" prop="name">
                    <el-input size="mini" maxlength="32" style="width: 350px" show-word-limit  v-model="majorItemForm.name" placeholder="请输入科目名称" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="考试日期" prop="examDay">
                    <el-date-picker
                            style="width:350px"
                            size="mini"
                            v-model="majorItemForm.examDay"
                            type="date"
                            placeholder="选择考试日期"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="考试时间" prop="examStartTime">
                    <el-time-picker
                            size="mini"
                            is-range
                            v-model="majorItemForm.examStartTime"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            placeholder="选择时间范围"
                            format="HH:mm"
                            value-format="HH:mm">
                    </el-time-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button plain size="mini"  @click="dialog.dialogFormVisible = false">取 消</el-button>
                <el-button plain size="mini"  type="primary" v-if="dialog.title=='增加'" v-display:sysMajorItem-save @click="saveOrUpdateItem('majorItemForm')">确 定</el-button>
                <el-button plain size="mini"  type="primary" v-else v-display:sysMajorItem-update @click="saveOrUpdateItem('majorItemForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios'
    import ckeditor from '@/components/ckeditor-normal-math/editor'
    export default {
        name: "saveOrUpdateSysMajor",
        components: {ckeditor},
        props: ['title','id','type'],
        data(){
            return {
                upsertForm:{
                    adminId: '',
                    adminName: '',
                    code: '',
                    name: '',
                    year: '',
                    majorCode: '',
                    type: '',
                    xz: '',
                    updateTime: '',
                    createTime: '',
                },
                rules: {
                  adminId: [
                          { required: true, message: '请输入创建人编', trigger: 'blur' },
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  adminName: [
                          { required: true, message: '请输入创建人', trigger: 'blur' },
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  code: [
                          { required: true, message: '请输入专业编码', trigger: 'blur' },
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  name: [
                          { required: true, message: '请输入专业名称', trigger: 'blur' },
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                    year: [
                        { required: true, message: '请选择生效年份', trigger: 'blur' },
                    ],
                    majorCode: [
                        { required: true, message: '请输入专业编号', trigger: 'blur' },
                        {  max: 2, message: '长度必须少于2个字符', trigger: 'blur' }
                    ],
                  updateTime: [
                          { required: true, message: '请输入修改时间', trigger: 'blur' },
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  createTime: [
                          { required: true, message: '请输入创建时间', trigger: 'blur' },
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                },
                majorItemForm:{
                    id:'',
                    sequence:'',
                    adminId:'',
                    adminName:'',
                    majorId:'',
                    name:'',
                    examDay:'',
                    examStartTime:'',
                    examEndTime:'',
                    udpateTime:'',
                    createTime:''
                },
                majorRules: {
                    name: [
                        { required: true, message: '请输入科目名称', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    examDay: [
                        { required: true, message: '请选择考试日期', trigger: 'blur' },
                    ],
                    examStartTime: [
                        { required: true, message: '请选择考试时间', trigger: 'blur' },
                    ],
                },
                dialog:{
                    dialogFormVisible:false,
                    title:'增加'
                },
                tableData:[],
                searchForm:{
                    sequence:'',
                    adminId: '',
                    adminName: '',
                    majorId: '',
                    name: '',
                    examDay: '',
                    examStartTime: '',
                    examEndTime: '',
                    udpateTime: '',
                    createTime: '',
                    pager:{
                        sortField:'sequence',
                        sortOrder:'asc',
                        page:1,
                        pageSize:10,
                        totalCount:0
                    }
                },
            }
        },
        created(){
          if(this.title=='修改'){
              axios({
                  url:`${home}/sysMajor/update/findSysMajorById/${this.id}`,
                  method:'GET'
              }).then(res=>{
                  Object.assign(this.upsertForm,res.data);
              }).catch(error=>{

              })
              this.submit(this.id);
          }
        },
        mounted(){

        },
        methods:{
            saveOrUpdate(formName){
                this.$refs[formName].validate(valid=>{
                    if(valid){
                        this.upsertForm.type = this.type;
                        axios({
                            url:`${home}/sysMajor/${this.title==='增加'?'saveSysMajor':'update/updateSysMajor'}`,
                            method:'POST',
                            data:this.upsertForm
                        }).then(res=>{
                            this.$message({
                                message: this.title+'成功',
                                type: 'success'
                            });
                            this.$emit('closeSaveOrUpdate',true);
                        }).catch(error=>{
                            //do something
                        })
                    }
                })
            },
            showAddDialog(){
                this.dialog.dialogFormVisible=true;
                this.dialog.title='增加';
                objUtil.setToDefault(this.majorItemForm);
                this.$nextTick(()=>{
                    this.$refs.majorItemForm.clearValidate();
                });
            },
            showUpdateDialog(id){
                axios({
                    url:`${home}/sysMajorItem/update/findSysMajorItemById/${id}`,
                    method:'GET'
                }).then(res=>{
                    Object.assign(this.majorItemForm,res.data);
                    if(res.data.examStartTime && res.data.examEndTime){
                        this.majorItemForm.examStartTime = [];
                        this.majorItemForm.examStartTime.push(res.data.examStartTime);
                        this.majorItemForm.examStartTime.push(res.data.examEndTime);
                    }
                    this.dialog.dialogFormVisible=true;
                    this.dialog.title = '修改';
                    this.$nextTick(()=>{
                        this.$refs.majorItemForm.clearValidate();
                    });
                }).catch(error=>{

                })
            },
            saveOrUpdateItem(formName){
                this.$refs[formName].validate(valid=>{
                    if(valid){
                        if(this.majorItemForm.examStartTime){
                            var times = this.majorItemForm.examStartTime;
                            times = times.toString().split(",");
                            this.majorItemForm.examStartTime = times[0];
                            this.majorItemForm.examEndTime = times[1];
                        }
                        this.majorItemForm.majorId = this.id;
                        axios({
                            url:`${home}/sysMajorItem/${this.dialog.title==='增加'?'saveSysMajorItem':'update/updateSysMajorItem'}`,
                            method:'POST',
                            data:this.majorItemForm
                        }).then(res=>{
                            this.$message({
                                message: this.dialog.title+'成功',
                                type: 'success'
                            });
                            this.dialog.dialogFormVisible = false;
                            this.submit(this.id);
                        }).catch(error=>{
                            //do something
                        })
                    }
                })
            },
            deleteData(id){
                this.$confirm('删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios({
                        url: `${home}/sysMajorItem/deleteSysMajorItem/${id}`,
                        method: 'GET'
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.submit(this.id);
                    }).catch(error => {

                    })
                }).catch(() => {

                });

            },
            submit(id){
                if(id){
                    this.searchForm.majorId = id;
                    axios({
                        url:`${home}/sysMajorItem/findSysMajorItemsByCondition`,
                        method:'POST',
                        data:this.searchForm
                    }).then(res=>{
                        this.tableData=res.data;
                    }).catch(function (error) {
                        console.log(error);
                    });
                }

            },
            close(){
                this.$emit('closeSaveOrUpdate');
            },
        }
    }
</script>

<style scoped lang="scss">
    .saveOrUpdateCrud{
        margin: 20px 0 0 10px;
    }
</style>
